<template>
    <div>
        <div v-if="!hasSelectedSelfInstall"
             class="bg-white
                        rounded-md
                        shadow
                        p-6
                        mb-4 print:-my-8 print:shadow-none">
            <h3 class="text-lg
                           mb-4">
                Installation Date
            </h3>

            <div class="font-bold
                            text-salmon">
                {{ formatInstallDate }}
            </div>
            <p class="text-sm">
                A service reminder text message has been sent to the phone number you provided during purchase.
            </p>
            <div class="text-sm mt-2">
                What to expect:
                <div class="m-2">
                    <IconCheck class="inline mr-1" /> A Professional Tech will arrive at your home to install and set up your service
                </div>
                <div class="m-2">
                    <IconCheck class="inline mr-1" /> Outdoor check of signal strength to validate your home's connection
                </div>
            </div>
        </div>
        <div v-else-if="isTechDelivered && hasSelectedSelfInstall"
             class="bg-white
                        rounded-md
                        shadow
                        p-6
                        mb-4 print:-mt-10">
            <h3 class="text-lg
                           mb-4">
                Self Installation
            </h3>
            <div v-if="formatInstallDate"
                 class="font-bold
                            text-salmon">
                {{ formatInstallDate }}
            </div>
            <p class="text-sm">
                Your Self Installation Kit is scheduled for delivery (call 888-640-9761 to change your drop off date).
            </p>
            <div class="text-sm my-2">
                What to expect:
                <div class="m-2">
                    <IconCheck class="inline mr-1" /> Contact-free way to get set up and connected fast
                </div>
                <div class="m-2">
                    <IconCheck class="inline mr-1" /> Self-Installation Kit is easy to use and is delivered directly to your door (no one is required to be home when your kit is delivered)
                </div>
                <div class="mt-2 mx-2">
                    <IconCheck class="inline mr-1" /> A Professional will call you in advance of the delivery
                </div>
            </div>
            <small v-if="isEquipmentSelected({ name: 'Customer Owned Modem' })">
                A Breezeline technician will leave a Customer Owned Modem self install kit at your door on your install date. Once you have installed your own modem, please contact the call center at 888-536-9600 to activate your service.
            </small>
        </div>
        <div v-else-if="hasSelectedSelfInstall"
             class="bg-white
                        rounded-md
                        shadow
                        p-6
                        mb-4 print:-mt-10">
            <h3 class="text-lg
                           mb-4">
                Self Installation
            </h3>
            <div v-if="formatInstallDate"
                 class="font-bold
                            text-salmon">
                {{ formatInstallDate }}
            </div>
            <p class="text-sm">
                A confirmation email will be sent to you within 24 hours which will include your UPS tracking information for your self-installation shipment.<br> Your shipment should arrive in 3-5 business days.
            </p>
            <div class="text-sm mt-2">
                What to expect:
                <div class="m-2">
                    <IconCheck class="inline mr-1" /> Contact free way to save money and get set up and connected fast
                </div>
                <div class="m-2">
                    <IconCheck class="inline mr-1" /> Self-Installation Kit is easy to use and is delivered directly to your door (no one is required to be home when your kit is delivered)
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import IconCheck from "@/atoms/icons/IconCheck"
export default {
    name: "InstallationInfo",
    components: {
        IconCheck,
    },
    props: {
        hasSelectedSelfInstall: {
            type: Boolean,
            required: true
        },
        isTechDelivered: {
            type: Boolean,
            required: true
        },
        formatInstallDate: {
            type: String,
            required: true
        },
        isEquipmentSelected: {
            type: Function,
            required: true
        }
    }
}
</script>

<style scoped>

</style>